var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContractEdit = function SvgContractEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_8372",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_8372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65956 7.24344V6.16011H14.3391V7.24344H7.65956ZM7.65956 9.6474V8.56407H14.3391V9.6474H7.65956ZM10.4352 17.5832H4.99935C4.55602 17.5832 4.18129 17.4302 3.87518 17.1241C3.56907 16.818 3.41602 16.4432 3.41602 15.9999V13.0961H5.41602V2.41656H16.5827V9.46469C16.3689 9.49455 16.1745 9.5458 15.9993 9.61844C15.8241 9.69108 15.6574 9.799 15.4993 9.94219V3.4999H6.49935V13.0961H12.2477L11.1643 14.1793H4.49935V15.9999C4.49935 16.1416 4.54727 16.2603 4.6431 16.3561C4.73893 16.452 4.85768 16.4999 4.99935 16.4999H10.4352V17.5832ZM12.0956 17.5832V15.5897L16.3904 11.3155C16.4698 11.234 16.5551 11.1771 16.6462 11.1447C16.7373 11.1123 16.8278 11.0961 16.9175 11.0961C17.0128 11.0961 17.1065 11.1137 17.1987 11.1489C17.2911 11.1841 17.3737 11.2371 17.4464 11.3076L18.3631 12.253C18.4332 12.3325 18.4873 12.4178 18.5254 12.5091C18.5636 12.6002 18.5827 12.6905 18.5827 12.7801C18.5827 12.8697 18.5651 12.9607 18.53 13.0532C18.495 13.1457 18.4394 13.231 18.3631 13.3091L14.0891 17.5832H12.0956ZM12.8391 16.8397H13.7766L16.3566 14.2674L15.8904 13.7882L15.44 13.3141L12.8391 15.9022V16.8397ZM15.8904 13.7882L15.44 13.3141L16.3566 14.2674L15.8904 13.7882Z",
    fill: "#152A58"
  }))));
};
export default SvgContractEdit;